module.exports = __webpack_public_path__ + "img/16.ce3223e9.png";